import { IWarranty } from "../models/warrantyModel";
import { warrantyRepo } from "../repositories";

export default {
  getInfoWarranty: async (
    uid: string,
    callback: (data: IWarranty | null, err: any) => void
  ) => {
    try {
      const rs = await warrantyRepo.getInfoWarranty(uid);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getInfoWarrantyWeb: async (
    uid: string,
    callback: (data: IWarranty | null, err: any) => void
  ) => {
    try {
      const rs = await warrantyRepo.getInfoWarrantyWeb(uid);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  validateWarrantyInfo: async (
    uid: string,
    keyword: string,
    callback: (data: IWarranty | null, err: any) => void
  ) => {
    try {
      const rs = await warrantyRepo.validateWarrantyInfo(uid, keyword);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  submitActiveWarrantyInfo: async (
    model: any,
    callback: (data: any | null, err: any) => void
  ) => {
    try {
      const rs = await warrantyRepo.submitActiveWarrantyInfo(model);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  validateOTPActiveWarrantyInfo: async (
    otp: string,
    uid: string = "",
    callback: (data: any | null, err: any) => void
  ) => {
    try {
      const rs = await warrantyRepo.validateOTPActiveWarrantyInfo(otp, uid);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
